export const appendLocalStorage = (key: string, value: any) => {
  const localStr = sessionStorage.getItem(key);
  const localObj = JSON.parse(localStr || '{}');
  sessionStorage.setItem(key, JSON.stringify({ ...localObj, ...value }));
};

export const getLocalStorage = (key: string) => {
  const localStr = sessionStorage.getItem(key);
  return JSON.parse(localStr || '{}');
};

export const clearLocalStorage = (key: string) => {
  sessionStorage.removeItem(key);
};
